import { ipCountryQuery, configQuery } from '@gig/magic-common';
import { GAMES_SHOW_FAVOURITES_QUERY, GAMES_IS_PLAY_FOR_FUN_QUERY, GAMES_LOBBY_COMMAND_CHANGE, USER_LOGGED_IN_UPDATED, GAMES_SHOW_FAVOURITES_UPDATED, GAMES_IS_PLAY_FOR_FUN_UPDATED } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';

var GamesListService = /** @class */ (function () {
    function GamesListService() {
        this.lobby = null;
        this.lobbyPath = null;
        this.loggedIn = false;
        this.registerSchemas();
        this.registerQueries();
        this.subscribeToLobbyChanges();
        this.subscribeToLoggedInChanges();
    }
    GamesListService.prototype.registerQueries = function () {
        var _this = this;
        window.queryBus.subscribe(GAMES_SHOW_FAVOURITES_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.areFavouritesEnabled()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
        window.queryBus.subscribe(GAMES_IS_PLAY_FOR_FUN_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isPlayForFunEnabled()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
    };
    GamesListService.prototype.subscribeToLobbyChanges = function () {
        var _this = this;
        window.commandBus.subscribe(GAMES_LOBBY_COMMAND_CHANGE, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.lobby = (_b = (_a = event.payload) === null || _a === void 0 ? void 0 : _a.lobby) !== null && _b !== void 0 ? _b : null;
                        this.lobbyPath = (_d = (_c = event.payload) === null || _c === void 0 ? void 0 : _c.lobbyPath) !== null && _d !== void 0 ? _d : null;
                        return [4 /*yield*/, this.publishFavouritesIconUpdated()];
                    case 1:
                        _e.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    GamesListService.prototype.subscribeToLoggedInChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loggedIn = (_a = event.payload) !== null && _a !== void 0 ? _a : false;
                        return [4 /*yield*/, Promise.all([
                                this.publishFavouritesIconUpdated(),
                                this.publishIsPlayForFunUpdated(),
                            ])];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    GamesListService.prototype.publishFavouritesIconUpdated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var showFavourites;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.areFavouritesEnabled()];
                    case 1:
                        showFavourites = _a.sent();
                        window.eventBus.publish(GAMES_SHOW_FAVOURITES_UPDATED, showFavourites);
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesListService.prototype.publishIsPlayForFunUpdated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isPlayForFun;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isPlayForFunEnabled()];
                    case 1:
                        isPlayForFun = _a.sent();
                        window.eventBus.publish(GAMES_IS_PLAY_FOR_FUN_UPDATED, isPlayForFun);
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesListService.prototype.areFavouritesEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, enabled, showForLobby;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.loggedIn) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, Promise.all([
                                this.favouritesEnabled(),
                                this.shouldShowFavouritesForLobby(),
                            ])];
                    case 1:
                        _a = _b.sent(), enabled = _a[0], showForLobby = _a[1];
                        return [2 /*return*/, enabled && showForLobby];
                }
            });
        });
    };
    GamesListService.prototype.isPlayForFunEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, countries, ipCountry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.loggedIn) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, Promise.all([
                                this.getPlayForFunBlockedCountries(),
                                ipCountryQuery(),
                            ])];
                    case 1:
                        _a = _b.sent(), countries = _a[0], ipCountry = _a[1];
                        return [2 /*return*/, !countries.includes(ipCountry)];
                }
            });
        });
    };
    GamesListService.prototype.shouldShowFavouritesForLobby = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allowedLobbies;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.lobbyPath) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.getLobbiesWithRecentGames()];
                    case 1:
                        allowedLobbies = _a.sent();
                        return [2 /*return*/, allowedLobbies.includes(this.lobbyPath)];
                }
            });
        });
    };
    GamesListService.prototype.favouritesEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('gamePlay.favouritesEnabled')];
                    case 1: return [2 /*return*/, !!(_a.sent())];
                }
            });
        });
    };
    GamesListService.prototype.getLobbiesWithRecentGames = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, configQuery('lobbiesRoutesToShowLastPlayedGames')];
                    case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : [])];
                }
            });
        });
    };
    GamesListService.prototype.getPlayForFunBlockedCountries = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, configQuery('gamePlay.playForFunBlockedCountries')];
                    case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : [])];
                }
            });
        });
    };
    GamesListService.prototype.registerSchemas = function () {
        window.eventBus.register(GAMES_SHOW_FAVOURITES_UPDATED, {
            type: 'boolean',
        });
        window.queryBus.register(GAMES_IS_PLAY_FOR_FUN_UPDATED, {
            type: 'boolean',
        });
        window.commandBus.register(GAMES_LOBBY_COMMAND_CHANGE, {
            type: 'object',
            properties: {
                lobby: {
                    anyOf: [
                        {
                            type: 'string',
                        },
                        {
                            type: 'null',
                        },
                    ],
                },
                lobbyPath: {
                    anyOf: [
                        {
                            type: 'string',
                        },
                        {
                            type: 'null',
                        },
                    ],
                },
            },
        });
    };
    return GamesListService;
}());

export { GamesListService };
